module.exports = __webpack_public_path__ + "static/media/uk-popup-mobile.c0467ec3.svg";